import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Page from 'src/components/Page';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

import VpnLockIcon from '@mui/icons-material/VpnLock';
import NoAccounts from '../../icons/NoAccounts';
import PasswordField from '../../icons/PasswordField';

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.default,,
    height: '100%',
    paddingTop: theme.spacing(3)
  },
  image: {
    display: 'inline-block',
    maxWidth: '100%',
    width: 100,
    opacity: 0.1,
    padding: 5
  },
  imageHolder: {
    float: 'right'
  }
}));

const IpRestrictionView = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage) {
      const isRestricted = localStorage.getItem('is_restricted');
      if (!isRestricted) {
        navigate('/', {
          replace: true
        });
      } else {
        localStorage.removeItem('is_restricted');
      }
    }
  }, []);

  return (
    <Page className={classes.root} title="IP address is not permitted">
      <Box display="flex" flexDirection="column" height="100%">
        <Container maxWidth="sm">
          <Box padding={3} marginBottom={2}>
            <Typography align="center" variant="h1">
              Sorry, login request failed.
            </Typography>
          </Box>
          <Paper>
            <Box padding={3}>
              <Typography variant="subtitle1">
                Common reasons for this error are:
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <VpnLockIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="IP restrictions are enabled."
                    secondary="Please ensure that you are
                        connected to Zendesk VPN."
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <PasswordField />
                  </ListItemIcon>
                  <ListItemText
                    primary="Wrong credentials."
                    secondary="Please make sure you are using using
                        correct login credentials."
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <NoAccounts />
                  </ListItemIcon>
                  <ListItemText
                    primary="Account has been locked out."
                    secondary="To prevent any suspicious
                        login, account is put into locked mode if there are
                        multiple unsuccessful login attempt. Reach out to IT to
                        help you unlock your account."
                  />
                </ListItem>
              </List>
            </Box>
          </Paper>
          <Box padding={3}>
            <Typography color="textPrimary" variant="body2">
              If you need further help logging in, you may contact us via our
              Slack channel <strong>#ask-bootstrapper</strong> or via chat
              widget.
            </Typography>
          </Box>
          <Box padding={3} textAlign="center">
            <Button
              color="primary"
              onClick={(event) => {
                event.preventDefault();
                navigate('/sso', { replace: true });
              }}
              variant="outlined"
              startIcon={<ArrowBackIcon />}
            >
              Back to Login
            </Button>
            {/* <Typography color="textPrimary" variant="body2" align="center">
              Go back to{' '}
              <Link
                href="#"
                color="secondary"
                style={{
                  color: '#1976d2'
                }}
                onClick={(event) => {
                  event.preventDefault();
                  navigate('/sso', { replace: true });
                }}
              >
                login page
              </Link>
              .
            </Typography> */}
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default IpRestrictionView;
